import { render } from "./ExchangeSelect.vue?vue&type=template&id=795d37b2&scoped=true"
import script from "./ExchangeSelect.vue?vue&type=script&lang=js"
export * from "./ExchangeSelect.vue?vue&type=script&lang=js"

import "./ExchangeSelect.vue?vue&type=style&index=0&id=795d37b2&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795d37b2"]])

export default __exports__